export default __webpack_public_path__ + "static/media/logo-only.3cbc3bfe.png";